import type { ReactNode } from 'react';

/** One row in a list of clubs/athletes/competitions/starters — title + a
 *  subtitle line on the left, action buttons on the right. Shared across
 *  the "simple" CRUD views so each one isn't hand-rolling its own row
 *  layout. */
export function EntityRow({ title, sub, tags, actions }: { title: ReactNode; sub?: ReactNode; tags?: ReactNode; actions: ReactNode }) {
  return (
    <div className="flex items-center gap-3 rounded-lg border bg-card px-4 py-3">
      <div className="min-w-0 flex-1">
        <p className="truncate text-[14.5px] font-semibold tracking-tight text-foreground">{title}</p>
        {sub ? <p className="truncate font-mono text-xs text-muted-foreground">{sub}</p> : null}
        {tags ? <div className="mt-1.5 flex flex-wrap gap-1.5">{tags}</div> : null}
      </div>
      <div className="flex shrink-0 gap-1.5">{actions}</div>
    </div>
  );
}
